import { Component, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent {
  confirmEvent: EventEmitter<boolean> = new EventEmitter();

  confirm() {
    this.confirmEvent.emit(true);
  }

  decline() {
    this.confirmEvent.emit(false);
  }
}
